export function candleParser(candle) {
  const obj = {
    high: null,
    low: null,
    open: null,
    close: null,
    candleSymbol: null,
    candleStartTimeStamp: null,
    duration: null,
  };
  if (candle) {
    obj.high = candle.high ?? null;
    obj.low = candle.low ?? null;
    obj.open = candle.open ?? null;
    obj.close = candle.close ?? null;
    obj.candleSymbol = candle.candleSymbol ?? null;
    obj.candleStartTimeStamp = candle.candleStartTimeStamp ?? null;
    obj.duration = candle.duration ?? null;
  }
  return obj;
}
